import { render, staticRenderFns } from "./suspension_diagram1.vue?vue&type=template&id=e64ca4dc&scoped=true"
import script from "./suspension_diagram1.vue?vue&type=script&lang=js"
export * from "./suspension_diagram1.vue?vue&type=script&lang=js"
import style0 from "./suspension_diagram1.vue?vue&type=style&index=0&id=e64ca4dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64ca4dc",
  null
  
)

export default component.exports